import Header from '../Components/Heading';
import React from 'react';
import ClickCopyLabel from '../Components/ClickCopyLabel';
export default function HowTo() {
	return (
		<div className="grid justify-items-center">
			<div className="w-4/5">
				<Header text="Quick Snippets" type="h2" />
				<table className="table-auto border-2 w-full ">
					<thead className="border-1">
						<tr>
							<th>Snippet</th>
							<th>How to use</th>
						</tr>
					</thead>
					<tbody>
						<tr className="text-center ">
							<td className="border-2 p-5">
								BoarderedWithIconSnippet
								<br />
								<ClickCopyLabel
									text={'###BoarderedWithIconSnippet|{ICON}|{ICON COLOR}|{text}%%%%%'}
									label="Copy"
								/>
							</td>
							<td className="border-2 p-5">
								<ul className="list-disc">
									<li>
										<a
											href="https://ez-services-workspace.slack.com/archives/C037PB6M00H/p1657849899407559"
											className="no-underline hover:underline text-blue-400"
											target="_blank"
										>
											Example [video]
										</a>
									</li>
									<li>
										<a
											href="https://semantic-ui.com/elements/icon.html"
											className="no-underline hover:underline text-blue-400"
											target="_blank"
										>
											ICON
										</a>
									</li>
									<li>
										ICON COLOR: red, orange, yellow, olive, green, teal, blue, violet, purple, pink,
										brown, grey, black
									</li>
								</ul>
							</td>
						</tr>
						<tr className="text-center ">
							<td className="border-2 p-5">
								TLDRSnippet
								<br />
								<ClickCopyLabel
									text={'###TLDRSnippet|this is a test%%%%%'}
									label="Copy"
								/>
							</td>
							<td className="border-2 p-5">
								in the copy
							</td>
						</tr>
						<tr className="text-center ">
							<td className="border-2 p-5">
								Product Link
								<br />
								<ClickCopyLabel
									text={'***amazon_key|anchor text***'}
									label="Copy"
								/>
							</td>
							<td className="border-2 p-5">
								in the copy
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}
